@use "@fukuri-admins/ui/layout" as *;

.content {
  display: flex;
  flex-direction: column;
  gap: spacing('24');
  padding: spacing('24');
  height: 100%;
}

